import type { OnlineToolsTeaserDataObject } from './online-tools-teaser.config';
import { onlineToolsTeaserDataObjects } from './online-tools-teaser.config';

// merge the teaserData from each subcategory with the missing data from the parent
export const getFlattenedOnlineToolsTeaserData = (teaserData: OnlineToolsTeaserDataObject) => {
  const mergedTeaserData = teaserData.map(teaserDataParent =>
    teaserDataParent.subcategories.map(teaserDataSubCategory => {
      const { subcategories: _, ...teaserDataParentWithoutSubcategories } = teaserDataParent;
      return { ...teaserDataParentWithoutSubcategories, ...teaserDataSubCategory };
    })
  );
  return mergedTeaserData.flat();
};

export const getOnlineToolsTeaserData = (selectedCategoryKey: string) =>
  getFlattenedOnlineToolsTeaserData(onlineToolsTeaserDataObjects).find(
    onlineToolsCategoryImage => onlineToolsCategoryImage.selectedCategoryKey === selectedCategoryKey
  );
